import { TeamsInSlackClient } from './TeamsInSlackClient';

const _default_1: TeamsInSlackClient = new TeamsInSlackClient();

export default _default_1;
